import { apiClient } from "@/services/api";

export default {
  submit(data) {
    return apiClient.post("/parking-pass", data);
  }
};
